import { Link } from 'react-router';
import { ArrowLeft } from 'lucide-react';

export function TutorProfileSkeleton() {
  return (
    <div className="w-full space-y-6 py-2">
      {/* Back button */}
      <div>
        <Link
          to="/tutors"
          className="inline-flex items-center gap-1.5 text-sm text-slate-500 hover:text-slate-800 dark:text-slate-400 dark:hover:text-slate-200 transition-colors font-semibold cursor-pointer group"
        >
          <ArrowLeft className="h-4 w-4 group-hover:-translate-x-0.5 transition-transform" />
          <span>Back to search</span>
        </Link>
      </div>

      {/* 1. Header Card Banner Skeleton */}
      <div className="relative overflow-hidden rounded-lg border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 shadow-sm">
        {/* Profile Details Row */}
        <div className="p-6 flex flex-col md:flex-row md:items-start justify-between gap-6">
          <div className="flex flex-col sm:flex-row items-center sm:items-start gap-4 text-center sm:text-left w-full">
            <div className="relative shrink-0">
              <div className="h-20 w-20 rounded-full bg-slate-200 dark:bg-slate-700 animate-pulse" />
            </div>

            <div className="space-y-2 flex-1 w-full">
              <div className="h-8 rounded-lg bg-slate-200 dark:bg-slate-700 animate-pulse w-48 mx-auto sm:mx-0" />
              <div className="h-5 rounded-lg bg-slate-200 dark:bg-slate-700 animate-pulse w-96 max-w-full mx-auto sm:mx-0" />
              <div className="h-4 rounded-lg bg-slate-200 dark:bg-slate-700 animate-pulse w-64 max-w-full mx-auto sm:mx-0" />
            </div>
          </div>

          {/* Rate Display */}
          <div className="flex flex-col items-center md:items-end gap-2 shrink-0 self-center md:self-auto w-full md:w-auto">
            <div className="h-10 w-28 rounded-lg bg-slate-200 dark:bg-slate-700 animate-pulse" />
          </div>
        </div>

        {/* Actions bar */}
        <div className="border-t border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-900 p-4 flex flex-wrap gap-3 justify-center sm:justify-start items-center">
          <div className="h-10 w-36 rounded-lg bg-slate-200 dark:bg-slate-700 animate-pulse" />
          <div className="h-10 w-44 rounded-lg bg-slate-200 dark:bg-slate-700 animate-pulse" />
          <div className="h-10 w-28 rounded-lg bg-slate-200 dark:bg-slate-700 animate-pulse ml-auto" />
        </div>
      </div>

      {/* 2. Content Split Grid Skeleton */}
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 items-start">
        {/* Left Column: Biography, Video, Credentials, Reviews */}
        <div className="col-span-1 lg:col-span-8 space-y-6">
          {/* Bio Section */}
          <section className="bg-white dark:bg-slate-800 p-6 rounded-lg border border-slate-200 dark:border-slate-700 shadow-sm space-y-3">
            <div className="h-6 bg-slate-200 dark:bg-slate-700 animate-pulse rounded-lg w-40" />
            <div className="space-y-2">
              <div className="h-4 bg-slate-200 dark:bg-slate-700 rounded animate-pulse" />
              <div className="h-4 bg-slate-200 dark:bg-slate-700 rounded animate-pulse w-5/6" />
              <div className="h-4 bg-slate-200 dark:bg-slate-700 rounded animate-pulse w-4/6" />
            </div>
          </section>

          {/* Qualifications & Experience Timeline */}
          <section className="bg-white dark:bg-slate-800 p-6 rounded-lg border border-slate-200 dark:border-slate-700 shadow-sm space-y-4">
            <div className="h-6 bg-slate-200 dark:bg-slate-700 animate-pulse rounded-lg w-56" />
            <div className="h-12 bg-slate-200 dark:bg-slate-700 animate-pulse rounded-lg" />
            <div className="space-y-3 pl-1.5 pt-1">
              <div className="h-4 bg-slate-200 dark:bg-slate-700 animate-pulse rounded w-36" />
              <div className="space-y-4 ml-2.5 pl-4 border-l border-slate-200 dark:border-slate-700">
                <div className="space-y-2">
                  <div className="h-4 bg-slate-200 dark:bg-slate-700 animate-pulse rounded w-48" />
                  <div className="h-3 bg-slate-200 dark:bg-slate-700 animate-pulse rounded w-32" />
                </div>
              </div>
            </div>
          </section>
        </div>

        {/* Right Column: Availability Calendar & Badge Filters */}
        <div className="col-span-1 lg:col-span-4 space-y-6">
          {/* Availability Card */}
          <div className="bg-white dark:bg-slate-800 p-5 rounded-lg border border-slate-200 dark:border-slate-700 shadow-sm space-y-4">
            <div className="h-6 bg-slate-200 dark:bg-slate-700 animate-pulse rounded-lg w-36" />
            <div className="space-y-2">
              <div className="h-4 bg-slate-200 dark:bg-slate-700 animate-pulse rounded w-full animate-pulse mb-1" />
              <div className="h-4 bg-slate-200 dark:bg-slate-700 animate-pulse rounded w-full animate-pulse" />
            </div>
          </div>

          {/* Subjects & Grades badge card */}
          <div className="bg-white dark:bg-slate-800 p-5 rounded-lg border border-slate-200 dark:border-slate-700 shadow-sm space-y-4">
            <div className="h-6 bg-slate-200 dark:bg-slate-700 animate-pulse rounded-lg w-36" />
            <div className="space-y-2">
              <div className="h-4 bg-slate-200 dark:bg-slate-700 animate-pulse rounded w-1/2 mb-1" />
              <div className="h-8 bg-slate-200 dark:bg-slate-700 animate-pulse rounded-lg w-full" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

